document.addEventListener("DOMContentLoaded", () => {
  const scrollButton = document.getElementById("scrollToTop");

  if (scrollButton) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        scrollButton.classList.add("is-visible");
      } else {
        scrollButton.classList.remove("is-visible");
      }
    });

    scrollButton.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
});
